export default __webpack_public_path__ + "static/media/blue-round.55d3a67f.svg";